import  styled from 'styled-components';

export const  Container =styled.div`
.kycExpMdl{
    padding: 32px;
}
.kycExpMdl__hdr{
    display: flex;
    align-items: center;
    margin-bottom: 26px;
}
.kycExpMdl__info{
    padding: 10px;
    border-radius: 4px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 900;
    margin-bottom: 24px;
    text-align: center;
}
.kycExpMdl__info.yellow{
    background-color: #FFEDD1;
    color: #a3752b;
}
.kycExpMdl__info.red{
    background-color: #FFD3D4;
    color: #EB2026;
}
.kycExpMdl__ftr{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 24px;
}
.kycExpMdl__secondaryCta{
    padding: 10px 16px;
    border-radius: 4px;
    font-size: 14px;
    line-height: 20px;
}
.kycExpMdl__desc{
    font-size: 16px;
    line-height: 24px;
}
.kycExpMdl__desc span{
    font-weight: 900;
}`